import Button from "components/Button/Button"

function ButtonSecondary(props) {
  return <Button {...props} pattern="secondary" />
}

export default ButtonSecondary
